// components/Publisher/RedirectPublisherById.jsx
import { useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { publisherDetail } from "../../services/publisherService";
import { buildPublisherPath } from "../../utils/slugify";
import { AppContext } from "../../services/AuthContext";

export default function RedirectPublisherById() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { auth } = useContext(AppContext);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res = await publisherDetail(id, 1, auth?.token);
        if (!alive) return;
        if (res?.status === "OK") {
          const { title } = res.data || {};
          navigate(buildPublisherPath({ title, id }), { replace: true });
        } else {
          navigate("/home", { replace: true });
        }
      } catch {
        navigate("/home", { replace: true });
      }
    })();
    return () => { alive = false; };
  }, [id, navigate]);

  return null;
}
